<template>
    <v-toolbar color="blue" dark fixed app>
        <v-btn @click="goback" icon v-if="isToolbarBackBtnShow">
            <v-icon>{{ arrowIcon }}</v-icon>
        </v-btn>
        <v-toolbar-title
            class="title text-uppercase"
            :class="{ 'ml-1': isToolbarBackBtnShow }"
        >
            {{ pageTitle }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="close" icon>
            <v-icon>fas fa-times</v-icon>
        </v-btn>
    </v-toolbar>
</template>
<script>
import { mapState, mapGetters, mapMutations } from "vuex";
export default {
    name: "AppToolbar",
    computed: {
        ...mapState(["pageTitle", "isToolbarBackBtnShow", "authVerifiedType"]),
        ...mapGetters(["isRtl"]),
        arrowIcon() {
            return this.isRtl ? "fas fa-arrow-right" : "fas fa-arrow-left";
        }
    },
    methods: {
        ...mapMutations({
            changeAuthVerified: "CHANGE_AUTH_VERIFIED",
            commitWV: "COMMIT_WEB_VIEW"
        }),
        close() {
            this.commitWV({
                method: "closeWebView"
            });
        },
        goback() {
            if (
                ["email", "mobile", "question"].indexOf(this.authVerifiedType) >
                -1
            ) {
                this.changeAuthVerified("verification");
            }
            this.$router.back();
        }
    }
};
</script>
